import { RoundedPlane, ViewerModule } from '@g.frame/core';
import { Color } from 'three';
const styleConfig = {
    radius: 0.0085,
};
const colorsConfig = {
    brown: new Color('#432A1C'),
    lightBrown: new Color('#FFF3DD')
};
export default class BackgroundElement extends ViewerModule {
    constructor() {
        super();
        this.uiObject.name = 'BackgroundElement';
    }
    set(newOptions) {
        this.options = newOptions;
        this.backgroundHeader && this.disposeObject(this.backgroundHeader);
        this.backgroundBody && this.disposeObject(this.backgroundBody);
        this.initBackground();
    }
    initBackground() {
        const headerNeeded = !!this.options.headerHeight;
        if (headerNeeded) {
            const headerSize = this.options.size.clone();
            headerSize.y = this.options.headerHeight;
            const headerOptions = {
                width: headerSize.x,
                height: headerSize.y,
                color: colorsConfig.brown.getHex(),
                r1: styleConfig.radius,
                r2: styleConfig.radius,
                r3: 0,
                r4: 0,
            };
            this.backgroundHeader = RoundedPlane.getRoundedPlane(headerOptions);
            this.addObject(this.backgroundHeader);
            this.backgroundHeader.position.set(0, (this.options.size.y - headerSize.y) / 2, 0.00025);
        }
        const bodySize = this.options.size.clone();
        const bodyOptions = {
            width: bodySize.x,
            height: bodySize.y,
            color: headerNeeded ? colorsConfig.lightBrown.getHex() : colorsConfig.brown.getHex(),
            r1: styleConfig.radius,
        };
        this.backgroundBody = RoundedPlane.getRoundedPlane(bodyOptions);
        this.addObject(this.backgroundBody);
        this.backgroundBody.position.z = 0;
    }
}
